<template>
  <div class="riclothes-footer" :class="{dark: this.$root.config.isDarkTheme}">
    <RiClothesButton color="green" text="テーマ切り替え" style="margin: 8px;" @onClick="changeTheme"></RiClothesButton>
    <RiClothesCheckbox checkboxId="saveToCookie" text="テーマの設定をCookieに保存する" color="white" @onChangeValue="changeCookieValue" v-model="isCheckSaveToCookie" />
    <RiClothesText textSize="1.3rem" style="color: #d1d1d1; text-align: right; margin-top: 16px; padding-bottom: 8px;">© 2020 riku1227</RiClothesText>
  </div>
</template>

<script>
import RiClothesText from "@/components/RiClothesText.vue";
import RiClothesButton from "@/components/RiClothesButton.vue";
import RiClothesCheckbox from "@/components/RiClothesCheckbox.vue";

const setThemeCookie = function(vue) {
  if(vue.$cookie.get("isSaveToCookie", "bool")) {
    vue.$cookie.set("isDarkTheme", vue.$root.config.isDarkTheme);
  } else {
    vue.$cookie.remove("isDarkTheme");
  }
}

export default {
  name: "ri-clothes-footer",
  data() {
    return {
      isCheckSaveToCookie: false
    }
  },

  created() {
    if(this.$cookie.get("isSaveToCookie", "bool")) {
      this.isCheckSaveToCookie = true;

      this.$root.config.isDarkTheme = this.$cookie.get("isDarkTheme", "bool");
      console.log(this.$root.config.isDarkTheme);
    } else {
      this.isCheckSaveToCookie = false;
    }
  },

  components: {
    RiClothesText,
    RiClothesButton,
    RiClothesCheckbox
  },

  methods: {
    changeTheme: function() {
      this.$root.config.isDarkTheme = !this.$root.config.isDarkTheme;
      setThemeCookie(this);
    },

    changeCookieValue: function () {
      console.log(this.isCheckSaveToCookie);

      if(this.isCheckSaveToCookie) {
        this.$cookie.set("isSaveToCookie", true);
      } else {
        this.$cookie.remove("isSaveToCookie");
      }

      setThemeCookie(this);
    }
  }
}
</script>

<style lang="scss" scoped>
.riclothes-footer {
  --footer-background-color: #575757;

  width: 100%;
  background: var(--footer-background-color);
  text-align: right;
  transition: 0.5s;
}

.dark {
  --footer-background-color: #303030;;
}
</style>